import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { collections as collectionsApi, purchases as purchasesApi } from '../api';
import './CollectionDetail.css';

const CollectionDetail = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [collection, setCollection] = useState(null);
  const [owned, setOwned] = useState(false);

  useEffect(() => {
    collectionsApi.getById(id).then(setCollection);
    if (user) {
      purchasesApi.myCollections().then(data => {
        setOwned(data.collections.some(c => c.collectionId === id));
      }).catch(() => {});
    }
  }, [id, user]);

  if (!collection) return <div className="loading">Loading...</div>;

  const handlePurchase = async () => {
    if (!user) { navigate('/login'); return; }
    await purchasesApi.checkout(id);
    navigate('/dashboard');
  };

  return (
    <div className="collection-detail">
      <nav className="nav">
        <div className="nav-content">
          <Link to="/" className="logo">C3</Link>
          <div className="nav-links">
            {user ? (
              <Link to="/dashboard" className="btn-secondary">Dashboard</Link>
            ) : (
              <Link to="/login" className="btn-secondary">Login</Link>
            )}
          </div>
        </div>
      </nav>

      <div className="detail-content">
        <div className="detail-header">
          <h1>{collection.title}</h1>
          <p className="detail-description">{collection.description}</p>
          <div className="detail-meta">
            <div className="meta-item"><strong>{collection.totalCards}</strong><span>Total Cards</span></div>
            <div className="meta-item"><strong>{collection.domains.length}</strong><span>Domains</span></div>
            <div className="meta-item"><strong>${(collection.price / 100).toFixed(2)}</strong><span>Price</span></div>
          </div>
          <div className="button-group">
            {owned ? (
              <>
                {[5, 10, 15].map(n => (
                  <Link key={n} to={`/study/${id}?size=${n}`} className="btn-primary btn-large">Study {n} Cards</Link>
                ))}
              </>
            ) : (
              <>
                {user && (
                  <Link to={`/study/${id}?preview=true`} className="btn-secondary btn-large">Try 5 Cards Free</Link>
                )}
                <button onClick={handlePurchase} className="btn-primary btn-large">Purchase Collection</button>
              </>
            )}
          </div>
        </div>

        <div className="domains-section">
          <h2>Domains Covered</h2>
          <div className="domains-list">
            {collection.domains.map((domain, i) => (
              <div key={i} className="domain-tag">{domain}</div>
            ))}
          </div>
        </div>

        {collection.preview && user && (
          <div className="domains-section">
            <h2>Preview</h2>
            {collection.preview.map(card => (
              <div key={card.cardId} style={{padding: '1rem', borderBottom: '1px solid #e0e0e0'}}>
                <span style={{color: '#2563eb', fontSize: '0.85rem'}}>{card.domain}</span>
                <p>{card.front}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CollectionDetail;
